module.exports = __webpack_public_path__ + "img/product_mb_01.a4687b8.webp";